import { render, staticRenderFns } from "./posPurchases.vue?vue&type=template&id=4c9b3af8&scoped=true&"
import script from "./posPurchases.vue?vue&type=script&lang=js&"
export * from "./posPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b3af8",
  null
  
)

export default component.exports